import { useEffect, useState } from "react";
import {
  getOffers,
  getOfferById,
  createOffer,
  updateOffer,
  deleteOffer,
}  from "../../../api/offer.api";

export default function useOffers() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadOffers = async () => {
    setLoading(true);
    const res = await getOffers();
    setData(res.data || []);
    setLoading(false);
  };

  const loadOfferById = async (id) => {
    const res = await getOfferById(id);
    return res.data?.data;
  };

  const addOffer = async (payload) => {
    return await createOffer(payload);
  };

  const editOffer = async (id, payload) => {
    return await updateOffer(id, payload);
  };

  const removeOffer = async (id, payload) => {
    return await deleteOffer(id, payload);
  };

  useEffect(() => {
    loadOffers();
  }, []);

  return {
    data,
    loading,
    loadOffers,
    loadOfferById,
    addOffer,
    editOffer,
    removeOffer,
  };
}
